export default __webpack_public_path__ + "static/media/R5No1.491a3fd7.mp3";